const lbaRedirect = angular.module('app.lbaRedirect', []);

lbaRedirect.component('lbaRedirect', {
  controllerAs: 'vm',
  controller: ['$location', lbaRedirectCtrl],
  template: `<div>Redirecting...</div>`
});

function lbaRedirectCtrl($location) {
  const currentPath = $location.path().split('/');
  currentPath.pop();
  $location.path(currentPath.join('/'))
}

export default lbaRedirect;


// WEBPACK FOOTER //
// ./src/components/lbaRedirect/lbaRedirect.js